import { gql } from "@apollo/client";

export const listStoreGroups = gql`
  query ListStoreGroups($field: String!, $type: KeywordGroupType!) {
    getDistinctKeywordGroupsField(field: $field, type: $type)
  }
`;
